import * as React from "react";
import { Grid } from "semantic-ui-react";
import { Connectors } from "../Connectors/Connectors";

interface RowWithContentProps {
	direction: "none" | "left" | "right";
	renderItem: (item: number) => React.ReactNode;
	itemsPerRow: number;
	// renderLeft: () => React.ReactNode;
	// renderRight: () => React.ReactNode;
}

const createColumns = (props: RowWithContentProps) => {
	let result = [];
	let keyCounter = 0;
	let itemCounter = 0;
	while (itemCounter != props.itemsPerRow) {
		result.push(
			<Grid.Column style={{ padding: 0 }}>
				{props.renderItem(itemCounter)}
			</Grid.Column>
		);
		itemCounter++;
		if (itemCounter == props.itemsPerRow) return result;
		// result.push(
		// 	props.direction === "none"
		// 		? null
		// 		: React.createElement(getConnector(props.direction), {
		// 				height: 50
		// 		  })
		// );
	}
	return result;
};

const RowWithContent: React.SFC<RowWithContentProps> = props => (
	<Grid.Row style={{ padding: 0 }}>{createColumns(props)}</Grid.Row>
);

const getConnector = (direction: "none" | "left" | "right") => {
	switch (direction) {
		case "none":
			return null;
		case "left":
			return Connectors.Left;
		case "right":
			return Connectors.Right;
	}
};

export default RowWithContent;



// WEBPACK FOOTER //
// ./src/components/SubQuadNavigation/Grid/RowWithContent.tsx